import { Form, Formik, FormikErrors, FormikProps } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';

const validate = async (values): Promise<FormikErrors<any>> =>  {
    const error: any = {
        mapping: 'failed'
    }
    return error;
}

class MappingsForm extends React.Component<any, any> {
    
    public render() {
        return (
            <div style={this.props.style}>
                <Formik
                    initialValues={{
                        mappings: JSON.stringify(this.props.config.mappings, null, 2)
                    }}
                    onSubmit={this.props.onSubmit}
                    render={this.form}
                    validate={validate}
                    enableReinitialize={true}
                />
            </div>
        );
    }
    private form = (p: FormikProps<any>) => <Form>
        <TextField
            label='Mappings'
            name='mappings'
            margin="normal"
            variant="outlined"
            placeholder={JSON.stringify({
                'ctx.xxx.xxx': {
                  identity: {
                    field: 'LastName',
                    type: 'userId'
                  },
                  table: 'Contact',
                  field: 'Phone',
                }
              }, null, 2)}
            multiline={true}
            fullWidth={true}
            rows="4"
            value={p.values.mappings}
            onChange={p.handleChange}
            onBlur={p.handleBlur}
        />
        <Button style={{width: '100%'}} type="submit" color="primary">Save</Button>
    </Form>
}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(MappingsForm));



// WEBPACK FOOTER //
// ./src/sub-projects/hubspot/components/mappings-form.tsx